module.exports = {
    centroidsMerge: require('array-xy-centroids-merge'),
    closestX: require('array-xy-closest-x'),
    maxMerge: require('array-xy-max-merge'),
    weightedMerge: require('array-xy-weighted-merge'),
    sortX: require('array-xy-sort-x'),
    maxY: require('array-xy-max-y')
};


// WEBPACK FOOTER //
// ./index.js